import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from '../constants';
export function getBucketStreamId(params) {
    return [
        reduxKey,
        'bucket',
        params.folder,
        params.bucket,
        params.filterId
    ].join(':');
}
export function getDrawerStreamId(params) {
    return [
        reduxKey,
        'drawer',
        params.folder
    ].join(':');
}
export function getNotificationCommentStreamId(params) {
    return [
        reduxKey,
        'comments',
        params.messageId
    ].join(':');
}
export function isBucketStream(streamId) {
    return streamId.startsWith(`${reduxKey}:bucket`);
}
export function isNotificationStream(streamId) {
    return streamId.startsWith(`${reduxKey}:bucket`) || streamId.startsWith(`${reduxKey}:drawer`);
}
export function isUser(val) {
    return val && typeof val === 'object' && val.hasOwnProperty('username');
}
export function ncCommentToPapiComment(comment) {
    var _comment_edited;
    return _object_spread_props(_object_spread({}, comment), {
        // Compat types
        edited: (_comment_edited = comment.edited) !== null && _comment_edited !== void 0 ? _comment_edited : null,
        isSpam: !!comment.isSpam,
        isDeleted: !!comment.isDeleted,
        isAuthor: !!comment.isAuthor,
        isAuthorHighlited: !!comment.isAuthorHighlited,
        isFeatured: !!comment.isFeatured,
        isReportable: !!comment.isReportable,
        isLiked: !!comment.isLiked,
        isOwner: !!comment.isOwner,
        // Removed
        // TODO need to refactor comments to not rely on the below, for now
        // and in the context on NC this should be good enough
        isViolation: false,
        isAdminHidden: false,
        isHidden: false,
        isLocked: false,
        isPrivate: false,
        isAnnotation: false,
        isAdminMode: false,
        hidden: null,
        signature: null,
        authorInfo: null
    });
}
export function isAllFeed(streamId) {
    return /user_feed_all|group_feed_all/.test(streamId);
}
export function isBucketSingleItem(item) {
    var _item_bucket_countDetails, _item_bucket;
    return item.bucket && item.message && ((_item_bucket = item.bucket) === null || _item_bucket === void 0 ? void 0 : (_item_bucket_countDetails = _item_bucket.countDetails) === null || _item_bucket_countDetails === void 0 ? void 0 : _item_bucket_countDetails.length) === 1 && item.bucket.countDetails[0].newCount === 1;
}
